import React from 'react';
import './IdleWarningModal.css';

const IdleWarningModal = ({
  visible = false,
  countdownSeconds = 0,
  onContinue,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="cq-idle-warning-overlay" role="dialog" aria-modal="true" aria-labelledby="idle-warning-title">
      <div
        className="cq-idle-warning-modal"
        style={{
          '--cq-idle-bg': `url(${process.env.PUBLIC_URL}/images/bg_artdeco_pattern_maroon.png)`,
          '--cq-idle-brass': `url(${process.env.PUBLIC_URL}/images/brass_plate_button.png)`,
        }}
      >
        <p className="cq-idle-warning-kicker">Session Check</p>
        <h2 id="idle-warning-title" className="cq-idle-warning-title">Are you still there?</h2>
        <p className="cq-idle-warning-message">
          The game has been idle for a while. Press Yes to keep playing.
        </p>
        <p className="cq-idle-warning-countdown" role="status" aria-live="polite">
          Auto-ending in {countdownSeconds} second{countdownSeconds === 1 ? '' : 's'}.
        </p>

        <button
          type="button"
          className="cq-idle-warning-button"
          onClick={onContinue}
        >
          <span className="cq-idle-warning-button__plate" aria-hidden="true" />
          <span className="cq-idle-warning-button__label">YES</span>
        </button>
      </div>
    </div>
  );
};

export default IdleWarningModal;
